<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component
    export class AccountMenuCustomItems extends Vue {
        render() {
            return null
        }
    }

    export default AccountMenuCustomItems
</script>
